import AccountHome from "../../views/Account/Home.vue";
import Personal from "../../views/Account/Personal.vue";
import Password from "../../views/Account/Password.vue";
import Subscription from "../../views/Account/Subscription.vue";
import Validation from "../../views/Account/Validation.vue";
import DiaryUrl from "../../views/Account/DiaryUrl.vue";

export default [
    {
        path: "/account",
        name: "Account",
        component: () => import("../../views/Account.vue"),
        redirect: { name: "accountHome" },
        children: [
            {
                path: "/",
                name: "accountHome",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: AccountHome,
            },
            {
                path: "personal",
                name: "personal",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: Personal,
            },
            {
                path: "validation",
                name: "validation",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: Validation,
            },
            {
                path: "diaryurl",
                name: "diaryurl",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: DiaryUrl,
            },
            {
                path: "password",
                name: "password",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: Password,
            },
            {
                path: "subscription",
                name: "subscription",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: Subscription,
            },
            {
                path: "privacy",
                name: "privacy",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: () => import("../../views/Account/Privacy.vue"),
            },
            {
                path: "club",
                name: "club",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: () => import("../../views/Account/Club.vue"),
            },
            {
                path: "security",
                name: "security",
                meta: {
                    isAuth: true,
                    isAccount: true,
                },
                component: () => import("../../views/Account/Security.vue"),
            },
        ],
    },
];
